import type { ModalConfig } from "./types";

export const contactModalsModalUrlConfig = {
  // Contact Modals
  "contacts-detail": {
    modalId: "contacts-detail",
    entityName: "contacts",
    singularParam: "contactId",
    pluralParam: "contactsId",
    displayName: "Contact",
  },
  "create-contacts": {
    modalId: "create-contacts",
    entityName: "contacts",
    singularParam: "contactId",
    pluralParam: "contactsId",
    displayName: "Contact",
  },
  "edit-contacts": {
    modalId: "edit-contacts",
    entityName: "contacts",
    singularParam: "contactId",
    pluralParam: "contactsId",
    displayName: "Contact",
  },
  // History & Audit is a PLACE (MODAL_BROWSER_HISTORY): registering it here is
  // what gives it a browser history entry — open pushes, close unwinds with
  // router.back(), Back closes it, Forward re-opens it. Unregistered, the
  // modal would still open but would silently drop out of history.
  "contacts-audit-history": {
    modalId: "contacts-audit-history",
    entityName: "contacts",
    singularParam: "contactId",
    pluralParam: "contactsId",
    displayName: "Contact",
  },
} as const satisfies Record<string, ModalConfig>;
